import React from 'react';
import { Navigate } from 'react-router-dom';

const PrivateRoute = ({ children, user }) => { 
  console.log("user: ",user);
  if (!(user && user.id)) {
    return <Navigate to="/login" />;
  }
  return children;
};

export default PrivateRoute;